module.exports = __webpack_public_path__ + "img/couples_15_H.3e782a04.webp";